import { __decorate } from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import IconSvg from "@/components/IconSvg.vue";
let ButtonApp = class ButtonApp extends Vue {
    constructor() {
        super(...arguments);
        this.circlesAmount = 3;
        this.animatedIndex = 0;
        this.timer = null;
    }
    created() {
        // if (this.isAnimated) {
        //   this.initAnimation()
        // }
    }
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
    initAnimation() {
        this.timer = setInterval(() => {
            this.animatedIndex === this.circlesAmount - 1
                ? (this.animatedIndex = 0)
                : this.animatedIndex++;
        }, 3000);
    }
    onClick() {
        if (this.isDisabled)
            return;
        this.$emit("clicked");
    }
};
__decorate([
    Prop({ default: "primary" })
], ButtonApp.prototype, "btnType", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isPlain", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "text", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isDisabled", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "iconLeft", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isUpper", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isFullWidth", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isMinimumWidth", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isLoading", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isAccent", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isCircleReverse", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isCircleHoverColored", void 0);
__decorate([
    Prop()
], ButtonApp.prototype, "isSmall", void 0);
ButtonApp = __decorate([
    Component({
        components: {
            IconSvg,
        },
    })
], ButtonApp);
export default ButtonApp;
